import { dispatch } from '@@/store';
const dealCheckedNum = (checkedKey) => {
    const checked = checkedKey.length;
    // desc 跨页多选
    // Object.keys(checkedKey).forEach((key) => {
    //   checked += checkedKey[key].length;
    // });
    return checked;
};
export const selectedTable = (selectedRowKeys, selectedRows, approve, mark) => {
    // desc 跨页多选
    // const CheckedKey = approve[`checkedKey${mark}`];
    // const checkedVal = approve[`checkedVal${mark}`];
    // const pageIndex = approve[`pageIndex${mark}`];
    // CheckedKey[`index_${pageIndex}`] = selectedRowKeys;
    // checkedVal[`index_${pageIndex}`] = selectedRows;
    const checkedNum = dealCheckedNum(selectedRowKeys);
    dispatch.approve.Selected_Table([
        {
            name: `checkedKey${mark}`,
            data: selectedRowKeys,
        },
        {
            name: `checkedVal${mark}`,
            data: selectedRows,
        },
        {
            name: `checkedNum${mark}`,
            data: checkedNum,
        }
    ]);
};
